import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DeleteCellComponent } from '@irb-common/components/grid/renderers/delete.cell.component';
import { DeleteHeaderComponent } from '@irb-common/components/grid/renderers/delete.header.component';
import { SettingsPortfoliosComponent } from '@irb/irb-settings/settings-portfolios/settings-portfolios.component';
import { UtilityService } from '@irb-common/services/utility.service';
import { AppService } from '@irb/app.service';
import { IrbAppEvents } from '@irb-common/events';
import { IAlertDialogData } from "@irb/app.model";
import { ValidationTextBoxRendererComponent } from "@irb/irb-common/components/grid/renderers/validation-text-box-renderer.component";

@Injectable({
    providedIn: 'root'
})
export class SettingsPortfoliosGridLayoutService implements GridLayoutService<SettingsPortfoliosComponent> {
    constructor(private util: UtilityService, private as: AppService) {}

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "ValidationTextBoxRendererComponent": ValidationTextBoxRendererComponent,
        };
    }

    getColumnDefs(parent: SettingsPortfoliosComponent) {
        return [{
            headerName: 'Delete All',
            headerComponent: 'DeleteHeaderComponent',
            headerComponentParams: { 
                disableDelete:!parent.isadmin,
                callBack: () => {
                    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                        dTitle: 'Delete All Labels?',
                        dProceedBtnLabel: 'Yes, Delete All Labels',
                        dCancelBtnLabel: 'Cancel',
                        msg: "Deleting all of the labels will remove them from your portfolios.",
                        onProceed: parent.deleteAllCategoryMenuItems.bind(parent),
                        onCancel: parent.cancelDelete.bind(parent)
                    } as IAlertDialogData);
                }
            },
            cellRenderer : 'DeleteCellComponent',
            cellRendererParams: { 
                disableDelete:parent.disableDelete.bind(parent),
                callBack: (params: any) => {
                    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                        dTitle: 'Delete Label?',
                        dProceedBtnLabel: 'Yes, Delete Label',
                        dCancelBtnLabel: 'Cancel',
                        msg: "Deleting this label will remove it from your portfolios.",
                        onProceed: () => { parent.deleteCategoryMenuItem(params) },
                        onCancel: parent.cancelDelete.bind(parent)
                    } as IAlertDialogData);
                }
            },
            resizable: false,
            maxWidth: 25,
            width: 25
        },
        {
            headerName: 'Label Name',            
            field: 'valueLabel',
            cellClass: "validationTextBoxCell",
            cellRenderer: "ValidationTextBoxRendererComponent",
            cellRendererParams: (_params: any) => {
                return {
                    regExp: "^[^\\^]+$",
                    max: 25,
                    disabled: !parent.isadmin,
                    onChange: (params: any, c: any) => {
                        if (params.data.valueLabel !== c.value) {
                            params.data.valueLabel = c.value.trim();
                            params.api.redrawRows({ rowNodes: [params.node] });
                            parent.onGridChange(params);
                        }
                    }
                };
            },
            sort: "asc",
            flex: 2,
            minWidth: 150,
            maxWidth: 220,
	    comparator: this.util.sortString.bind(parent)
        },
        {
            headerName: 'Label Description',
            field: 'categoryName',
            comparator: this.util.sortString.bind(parent),
            cellClass: "validationTextBoxCell",
            cellRenderer: "ValidationTextBoxRendererComponent",
            cellRendererParams: (_params: any) => {
                return {
                    max: 50,
                    disabled: !parent.isadmin,
                    onChange: (params: any, c: any) => {
                        if (params.data.categoryName !== c.value) {
                            params.data.categoryName = c.value;
                            params.api.redrawRows({ rowNodes: [params.node] });
                            parent.onGridChange(params);
                        }
                    }
                };
            },
			flex: 3,
            minWidth: 150,
            maxWidth: 630
        },
        {
            headerName: 'Assigned Portfolios',
            field: 'customCategoryCount',
            minWidth: 160,
            maxWidth: 180,
            flex: 1,
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null);
                },
                onClick: (function (data: any) {
                    parent.showPortfolioDetails(data);
                }).bind(this)
            },
        }];
    }
}
